import React from 'react';
import {Provider} from "components/role/RoleContext";
import {RoleList} from "components/role/RoleList";

export const Roles = () => {

    return (
        <Provider>
            <RoleList/>
        </Provider>
    );
}
